import type {RouteLocationNormalizedGeneric} from 'vue-router';
import useFeatures from '@/composables/useFeatures';

export const featureToggleGuard = (to: RouteLocationNormalizedGeneric) => {
  const {isFeatureActive} = useFeatures();
  if (!to?.meta?.feature) {
    return true;
  }

  if (isFeatureActive(to.meta.feature)) {
    return true;
  }

  // Set return url in localstorage so we can redirect back to the page after landing in meteor.
  localStorage.setItem('vueReturnUrl', to.fullPath);
  window.location.replace('/meteor');
  return false;
};
